export const [
    FETCH_STICKIES,
    UPDATE_INVOICED_START,
    UPDATE_INVOICED_END,
    UPDATE_STATUS,
    UPDATE_INVOICES,
    NEW_INVOICE,
] = [
    "FETCH_STICKIES",
    "UPDATE_INVOICED_START",
    "UPDATE_INVOICED_END",
    "UPDATE_STATUS",
    "UPDATE_INVOICES",
    "NEW_INVOICE",
]
